import { gql } from "@apollo/client";

export const getHealthQuestionnaireQuestions = gql`
  query HealthQuestionnaireQuestions($brandCode: String!, $productCode: String!, $dontExclude: Boolean) {
  healthQuestionnaireQuestions(brandCode: $brandCode, productCode: $productCode, dontExclude: $dontExclude) {
    code
    type
    required
    title
    description
    extraInfo
    selectionMode
    options {
      value
      label
    }
    columns {
      value
      label
    }
    rows {
      code
      label
    }
    followUp {
      code
      type
      required
      visibility {
        when
        parentQuestionCode
        operator
        value
        countWhere { answer }
      }
      requireWhen {
        when
        parentQuestionCode
        operator
        value
        countWhere { answer }
      }
      fields {
        code
        label
        required
        inputType
        options {
          label
          value
        }
      }
    }
    questions {
      code
      type
      required
      title
      description
      extraInfo
      options {
        value
        label
      }
      followUp {
        code
        type
        required
        visibility {
          when
          parentQuestionCode
          operator
          value
          countWhere { answer }
        }
        requireWhen {
          when
          parentQuestionCode
          operator
          value
          countWhere { answer }
        }
        fields {
          code
          label
          required
          inputType
          options {
            label
            value
          }
        }
      }
      questions {
        code
        type
        required
        title
        description
        extraInfo
        options {
          value
          label
        }
      }
    }
  }
}`;